// @flow
import type { AppState } from 'stores'
import { mapActiveMunicipality } from 'components/map/reducer'
import { EventListenerMap } from 'components/eventListenerMap/eventListenerMapComponent'
import { popupActions } from 'components/popup/reducer'
import { connect } from 'react-redux'

function mapStateToProps ({ interactionCapabilities }: AppState) {
  return {
    canHover: interactionCapabilities.hover,
    canTouch: interactionCapabilities.touch
  }
}

function mapDispatchToProps (dispatch: Dispatch) {
  return {
    mouseOverHandler: (id: number, event: SyntheticEvent<SVGPathElement>) => {
      if (!isNaN(id)) {
        event.stopPropagation()
        dispatch(mapActiveMunicipality(id))
        dispatch(popupActions.popup.position.takeFrom(event.currentTarget))
      }
    }
  }
}

const reduxConnectedEventListenerMap = connect(
  mapStateToProps,
  mapDispatchToProps
)(EventListenerMap)

export default reduxConnectedEventListenerMap
